var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,3L8.5,3C9.05228,3,9.5,3.447715,9.5,4L9.5,20C9.5,20.5523,9.05228,21,8.5,21L6,21C5.447715,21,5,20.5523,5,20L5,4C5,3.447715,5.447715,3,6,3M15,3L17.5,3C18.052300000000002,3,18.5,3.447715,18.5,4L18.5,20C18.5,20.5523,18.052300000000002,21,17.5,21L15,21C14.44771,21,14,20.5523,14,20L14,4C14,3.447715,14.44771,3,15,3",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.e52da73f33148a609828919333516ca7.svg";
export { ForwardRef as ReactComponent };